export enum MerchantRoleEnum {
  MerchantPortalSupervisor = 1,
  MerchantPortalApprover = 2,
  MerchantPortalPreparer = 3,
  MerchantPortalReportViewer = 4,
  MerchantPortalSupportStaff = 5,
}
